export default "__VITE_ASSET__CErKsZ7i__"